import { StandardResponse, TestingLocationResponse } from "@it-tc/legacy-api";
import emptySplitApi from "./emptySplitApi";

const extendedApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getPublicTestingLocations: builder.query<
      TestingLocationResponse[],
      undefined
    >({
      transformResponse: (
        response: StandardResponse<TestingLocationResponse[]>,
      ) => response.response,
      query: () => ({
        url: `${location.origin}/individualexamscheduler/services/public/v1/locations.json`,
      }),
    }),
  }),
});

export const {
  useGetPublicTestingLocationsQuery,
  useLazyGetPublicTestingLocationsQuery,
} = extendedApi;
